import React from 'react';
import { Container, Row, Col, Tab } from 'react-bootstrap';
import { Styles } from "./styles/tabBox.js";
import { useTranslation } from 'react-i18next';
const TabBox = () => {
    const { t } = useTranslation();

    return (
        <Styles>
            {/* Tab Box Area */}
            <section className="tab-section">
                <Container>
                    <Tab.Container defaultActiveKey="why">
                        <Row>
                            <Col lg="9" md="8">
                                <Tab.Content>
                                    <Tab.Pane eventKey="why">
                                        <h4 className="tab-title">{t('about.tab_title')}</h4>
                                        <p className="tab-desc">{t('about.p1')}</p>
                                        <p className="tab-desc">{t('about.p2_pre')} <span>Cozy Couture Int</span> {t('about.p2_mid')} <span>Cozy Couture Int. (CCI)</span> {t('about.p2_post')}</p>
                                        <p className="tab-desc">{t('about.p3')}</p>
                                    </Tab.Pane>
                                </Tab.Content>
                            </Col>
                        </Row>
                    </Tab.Container>
                </Container>
            </section>
        </Styles>
    )
}

export default TabBox